import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
  { path: '', redirectTo: 'initiatives', pathMatch: 'full' },
  {
    path: 'initiatives',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./pages/initiatives/initiative-list/initiative-list.component').then(
        (m) => m.InitiativeListComponent
      ),
  },
  {
    path: 'initiatives/:id',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./pages/initiatives/initiative-detail/initiative-detail.component').then(
        (m) => m.InitiativeDetailComponent
      ),
  },
  {
    path: 'dev-requests',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./pages/dev-requests/dev-request-list/dev-request-list.component').then(
        (m) => m.DevRequestListComponent
      ),
  },
  {
    path: 'dev-requests/:id',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./pages/dev-requests/dev-request-detail/dev-request-detail.component').then(
        (m) => m.DevRequestDetailComponent
      ),
  },
  {
    path: 'resource-requests',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./pages/resource-requests/resource-request-list/resource-request-list.component').then(
        (m) => m.ResourceRequestListComponent
      ),
  },
  {
    path: 'resource-requests/:id',
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./pages/resource-requests/resource-request-detail/resource-request-detail.component').then(
        (m) => m.ResourceRequestDetailComponent
      ),
  },
];
